import { EnvironmentName } from './environment.enum'
import packageJson from '../../../../package.json'

export const environment = {
  storeDevtools: false,
  name: EnvironmentName.Prod,
  version: packageJson.version,
}
